<template>
  <div class="app-container">
    <BjDivider right-fixed>{{ $t('AccountManagementAdd.titile') }}
      <template #right>
        <el-button @click="tryCancel">{{ $t('cancelText') }}</el-button>
        <el-button type="primary" @click="submit">{{ $t('okText') }}</el-button>
        <BjLogButton v-if="isEdit" :id="recordId" permission="BusinessUserAccountIndex_Log" :title="form.realName" api="roleApi" />
      </template>
    </BjDivider>
    <el-form ref="queryForm" :rules="rules" :model="form" label-width="150px" label-position="top">
      <el-row :gutter="20">
        <el-col :span="colSpan">
          <el-form-item :label="$t('AccountManagementAdd.account')" prop="loginName">
            <BjInput v-model="form.loginName" :maxlength="20" :disabled="isEdit" :placeholder="$t('AccountManagementAdd.place')" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('AccountManagementAdd.name')" prop="realName">
            <BjInput v-model="form.realName" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <BjFormItemMobile v-model="form.phone" prop="phone" :label="$t('AccountManagementAdd.phone')" clearable />
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('AccountManagementAdd.email')" prop="email">
            <BjInput v-model="form.email" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
          </el-form-item>
        </el-col>
        <el-col v-if="!isEdit" :span="colSpan">
          <el-form-item :label="$t('AccountManagementAdd.password')" prop="password">
            <BjInput v-model="form.password" :readonly="isEdit" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('AccountManagementAdd.from')" prop="startDateActive">
            <BjDatePicker v-model="form.startDateActive" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('AccountManagementAdd.until')" prop="endDateActive">
            <BjDatePicker v-model="form.endDateActive" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan" v-if="!$store.getters.cusId">
          <el-form-item :label="$t('billingPage.department')" prop="deptAbbr">
            <BjSelectLov v-model="form.deptAbbr" :option-list="operationList" multiple :placeholder="$t('billingPage.department')"/>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!-- <template v-if="isCustomerShow">
      <BjDivider>{{ $t('AccountManagementAdd.customerInfo.title') }}</BjDivider>
      <el-form ref="customerForm" :rules="rules" :model="form.customerInfo" label-width="150px" label-position="top">
        <el-row :gutter="20">
          <el-col :span="colSpan">
            <el-form-item :label="$t('AccountManagementAdd.customerInfo.clientCode')" prop="clientCode">
              <BjInputCode v-model="form.customerInfo.clientCode" :maxlength="MAX_LENGTH.NORMAL" :placeholder="$t('inputText')" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('AccountManagementAdd.customerInfo.clientFullName')" prop="clientFullName">
              <BjInput v-model="form.customerInfo.clientFullName" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('AccountManagementAdd.customerInfo.contactPerson')" prop="contactPerson">
              <BjInput v-model="form.customerInfo.contactPerson" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('AccountManagementAdd.customerInfo.companyName')" prop="companyName">
              <BjInput v-model="form.customerInfo.companyName" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('AccountManagementAdd.customerInfo.companyEnName')" prop="companyEnName">
              <BjInput v-model="form.customerInfo.companyEnName" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('AccountManagementAdd.customerInfo.isNom')" prop="isNom">
              <BjSelectLov v-model="form.customerInfo.isNom" :option-list="STATUS_YES_TRUE" />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('AccountManagementAdd.customerInfo.paymentTerm')" prop="paymentTerm">
              <BjInputNumber v-model="form.customerInfo.paymentTerm" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('AccountManagementAdd.customerInfo.ifLocal')" prop="ifLocal">
              <BjSelectLov v-model="form.customerInfo.ifLocal" :option-list="STATUS_YES_TRUE" />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('AccountManagementAdd.customerInfo.currencySymbol')" prop="currencySymbol">
              <BjSelectLov v-model="form.customerInfo.currencySymbol" lov-code="CHANNEL_CURRENCY" />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('AccountManagementAdd.customerInfo.bpCode')" prop="bpCode">
              <BjInputCode v-model="form.customerInfo.bpCode" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('AccountManagementAdd.customerInfo.billingAddress1')">
              <BjInput v-model="form.customerInfo.billingAddress1" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('AccountManagementAdd.customerInfo.billingAddress2')">
              <BjInput v-model="form.customerInfo.billingAddress2" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('AccountManagementAdd.customerInfo.billingAddressUnit')">
              <BjInput v-model="form.customerInfo.billingAddressUnit" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('AccountManagementAdd.customerInfo.billingAddressCity')" prop="billingAddressCity">
              <BjInput v-model="form.customerInfo.billingAddressCity" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('AccountManagementAdd.customerInfo.billingAddressState')" prop="billingAddressState">
              <BjInput v-model="form.customerInfo.billingAddressState" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('AccountManagementAdd.customerInfo.billingAddressCountry')" prop="billingAddressCountry">
              <BjInput v-model="form.customerInfo.billingAddressCountry" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('AccountManagementAdd.customerInfo.billingAddressPostcode')" prop="billingAddressPostcode">
              <BjInputCode v-model="form.customerInfo.billingAddressPostcode" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
             <BjFormItemMobile v-model="form.customerInfo.billingAddressPhone" prop="billingAddressPhone" :label="$t('AccountManagementAdd.customerInfo.billingAddressPhone')" required clearable />
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('AccountManagementAdd.customerInfo.billingAddressEmail')" prop="billingAddressEmail">
              <BjInput v-model="form.customerInfo.billingAddressEmail" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </template> -->

    <BjDivider>{{ $t('AccountManagementAdd.Role') }}</BjDivider>
    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button type="danger" icon="el-icon-delete" :disabled="multiple" class="delete-btn" @click="onDeleteSelected">{{ $t('delText') }}</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button type="primary" @click="onAdd">{{ $t('AccountManagementAdd.Add') }}</el-button>
      </el-col>
    </el-row>
    <el-table v-loading="loading" :data="roleTableData" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" align="center" />
      <el-table-column :label="$t('AccountManagementAdd.RoleName')" align="center" prop="name" />
      <el-table-column :label="$t('AccountManagementAdd.TenantName')" align="center" prop="tenantName" />
      <el-table-column :label="$t('AccountManagementAdd.from')" align="center" prop="name" width="250">
        <template slot-scope="scope">
          <BjDatePicker v-model="scope.row.startDateActive" />
        </template>
      </el-table-column>
      <el-table-column :label="$t('AccountManagementAdd.until')" align="center" prop="name" width="250">
        <template slot-scope="scope">
          <BjDatePicker v-model="scope.row.endDateActive" />
        </template>
      </el-table-column>
    </el-table>
    <pagination v-show="total > 0" :total="total" :page.sync="queryParams.page" :limit.sync="queryParams.size" />

    <BjDialogList ref="dialogList" :config="dialogListConfig" :disabled="disabledIds" multiple @confirm="onConfirmDialogList" />
  </div>
</template>
<script>
import viewMiXin from '@/utils/view-mixin.js';
import { roleApi,userApi } from '@/api';
import {GENDER_LIST, STATUS_YES_TRUE} from '@/utils/constants';
import { parseTime, validatePass } from '@/utils';

export default {
  name: 'ViewForm',
  mixins: [viewMiXin],
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    userInfo: {
      type: Object,
      default() {
        return null;
      },
    },
    userAllRoles: {
      type: Array,
      default() {
        return [];
      },
    },
    /** 公司 ids */
    companyLists: {
      type: Array,
      default() {
        return [];
      },
    },
    isCustomer: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      STATUS_YES_TRUE,
      colSpan: 8,
      pageName: 'BusinessUserAccountIndex',
      dialogListConfig: {
        title: this.$t('AccountManagementAdd.Add'),
        columns: [
          {
            prop: 'name',
            label: this.$t('AccountManagementAdd.RoleName'),
          },
          {
            prop: 'tenantName',
            label: this.$t('AccountManagementAdd.TenantName'),
          },
        ],
        search: [
          {
            placeholder: this.$t('AccountManagementAdd.ps'),
            key: 'name',
          },
        ],
        actionApi: roleApi.getRoleList,
        defaultQuery: {
          enabled: true,
          belongTo: this.$store.getters.cusId ? 2:1
        },
        query: '',
      },
      operationList:[],
      // 遮罩层
      loading: false,
      // 查询参数
      queryParams: {},
      title: '',
      dialogVisible: false,
      // 选中数组ids
      ids: [],
      // 选中数组
      selection: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      /** 数据总条数 */
      total: 0,
      // 日志查询参数
      recordId: null,
      // 表单参数
      form: {
        enabled: true,
        realName: null,
        internationalTelCode: null,
        loginName: null,
        deptAbbr:[],
        nickname: null,
        password: '',
        phone: null,
        email: null,
        gender: null,
        countryCode: null,
        countryName: null,
        regionId: null,
        addressDetail: null,
        birthday: null,
        startDateActive: null,
        endDateActive: null,
        // userType: null, // 用户类型（暂时用不到）
        memberRoleList: [],
        companyLists: [], // 组织架构 ids
        customerInfo: {
          billingAddress1: null,
          billingAddress2: null,
          billingAddressCity: null,
          billingAddressCountry: null,
          billingAddressEmail: null,
          billingAddressPhone: null,
          billingAddressPostcode: null,
          billingAddressState: null,
          billingAddressUnit: null,
          bpCode: null,
          clientCode: null,
          clientFullName: null,
          companyEnName: null,
          companyName: null,
          contactPerson: null,
          currencySymbol: null,
          ifLocal: null,
          isNom: null,
          paymentTerm: null
        }
      },
      // 表单校验
      rules: {
        realName: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        phone: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        startDateActive: [{ required: true, message: this.$t('AccountManagementAdd.ps2'), trigger: 'change' }],
        password: [{ required: true, validator: validatePass, trigger: 'blur' }],
        loginName: [{ required: true, trigger: 'blur', validator: this.validateLoginName }],
        deptAbbr: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
      },
      roleTableData: [],
      disabledIds: [],
      GENDER_LIST,
    };
  },
  watch: {
    userInfo: {
      handler(info) {
        if (info) {
          this.recordId = info.id;
          this.form = info;
          if(info.cusId){
            this.dialogListConfig.defaultQuery.belongTo = 2
          }
        }
      },
    },
    userAllRoles: {
      handler(roles) {
        if (roles) {
          /** */
          this.roleTableData = [].concat(roles);
        }
      },
    },
    companyLists: {
      handler(list) {
        this.form.companyLists = list;
      },
    },
  },
  created() {
    if (!this.isEdit) { this.form.startDateActive = parseTime(new Date(), '{y}-{m}-{d}'); }
    this.getDepartmentNameList()
  },
  methods: {
     // 获取操作部门下拉数据
     getDepartmentNameList(){
        userApi.getDepartmentList().then(res=>{
          this.operationList = res.map(item => {
            return { label: item.name, value: item.name };
          });
        })
      },
    validateLoginName(rule, value, callback) {
      if (rule.required && (!value || value === 0)) {
        callback(new Error(this.$t('PleaseAccountText')));
      } else {
        if (!/^[\u4e00-\u9fa5a-zA-Z0-9\s,.?!]{2,20}$/.test(value)) {
          callback(new Error(this.$t('PleaseCorrectAccountText')));
        } else {
          callback();
        }
      }
    },
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id);
      this.selection = selection;
      this.single = selection.length !== 1;
      this.multiple = !selection.length;
    },
    /** 选择国家清空地区数据 */
    handleChangeCountry(id, data) {
      this.form.countryCode = data.countryCode;
      this.form.regionId = null;
    },
    /** 选择组织架构 */
    onChangeCompany(data, node) {
      // 获取选中组织架构ids
      this.form.companyLists = node.checkedKeys;
    },
    /** 提交 */
    submit() {
      if (!this.roleTableData.length) {
        this.$message.warning(this.$t('AccountManagementAdd.ps3'));
        return;
      }
      this.$refs['queryForm'].validate(valid => {
        if (!valid) return this.$scrollToFormError();
        this.form.memberRoleList = this.roleTableData.map(e => {
          return {
            _innerMap: {},
            roleId: e.id,
            startDateActive: e.startDateActive,
            endDateActive: e.endDateActive,
          };
        });
        this.$emit('submit',{
              ...this.form,
              // 马光浩 2025/1/21
              deptAbbr:this.$store.getters.cusId ? 'AAA' : this.form.deptAbbr&&this.form.deptAbbr.join(",")
        });
      });
    },
    /**
     * START 添加角色操作
     */
    onAdd() {
      this.disabledIds = this.roleTableData.map(item => {
        return item.id;
      });
      this.$refs.dialogList.show();
    },
    onConfirmDialogList(data) {
      if (data && !data[0].id) return;
      if (this.isEdit) {
        this.$emit('addUserRoles', data.map(e => e.id));
      } else {
        data.forEach(element => {
          if (this.roleTableData.every(e => e.id != element.id)) {
            this.roleTableData.push({
              startDateActive: null,
              endDateActive: null,
              ...element,
            });
          }
        });
      }
    },
    /** END */
    /** 编辑操作 */
    onEdit() {
      this.title = this.$t('AccountManagementAdd.ps4');
      this.dialogVisible = true;
    },
    /** 删除操作 */
    onDeleteSelected() {
      const name = this.selection
        .map(item => {
          return item.name;
        })
        .join('，');
      this.$confirm(
        this.$t('AccountManagementAdd.ps5') +
          ' ' +
          name +
          ' ' +
          this.$t('AccountManagementAdd.ps6'),
        this.$t('AccountManagementAdd.ps7'),
        {
          confirmButtonText: this.$t('okText'),
          cancelButtonText: this.$t('cancelText'),
          type: 'warning',
          dangerouslyUseHTMLString: true,
        },
      )
        .then(() => {
          if (this.isEdit) {
            this.$emit('deleteUserRoles', this.ids);
          } else {
            this.ids.forEach(id => {
              const findIndex = this.roleTableData.findIndex(e => e.id == id);
              if (findIndex !== -1) {
                this.roleTableData.splice(findIndex, 1);
              }
            });
          }
        })
        .catch(() => {});
    },
  },
};
</script>
